/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import { LuiInputBase } from '@here/lui-base'
import scopedCss from 'lui-overflow.scss'
import template from 'lui-overflow.html'

export default class LuiOverflow extends LuiInputBase {
  static get is() {
    return 'lui-overflow'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  static get clickTriggers() {
    return ['space', 'enter', 'down', 'arrowdown']
  }

  static get clickEvent() {
    return 'mousedown'
  }

  static get hasLuiElementsInShadowDom() {
    return false
  }

  onConnected() {
    super.onConnected()
    this._onMousedownBound = this._onMousedownBound || this._onMousedown.bind(this)
    this.field.addEventListener('mousedown', this._onMousedownBound)
  }

  onDisconnected() {
    super.onDisconnected()
    this.field.removeEventListener('mousedown', this._onMousedownBound)
  }

  _onMousedown(event) {
    this.delay(() => this.action(event))
  }

  _onFocus(event) {
    super._onFocus(event)
  }

  action(event) {
    if (this.menu && event.target.closest('lui-menu') !== this.menu) {
      this.menu.open = true
    }
  }

  get menu() {
    this._menu = this._menu || this.querySelector('lui-menu')
    return this._menu
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-overflow/lui-overflow.js
// module id = 281
// module chunks = 0 1 29